import { TOGGLE_REPOSITORY_WATCH } from './';

export default (repositoryFullSlug: string) => ({
  type: TOGGLE_REPOSITORY_WATCH.REQUEST,
  payload: { repositoryFullSlug },
});
